module.exports = __webpack_public_path__ + "static/media/mustache-primary.e51753fa.svg";